import React, {Component} from 'react';
import {UncontrolledTooltip} from "reactstrap";
import {validateComponent, validateField} from "../../../common/validation";
import NumberFormat from "react-number-format";
import Select from "../../../local_node_modules/react-select"
import {deepCopyObject, showAxiosError} from "../../../helper/helper";
import {request} from "../../../helper/APIUtils";
import Alert from "react-s-alert";
import {ExternalCustomerMainType} from "../../../helper/enums";
import alert from "bootstrap/js/src/alert";


class ExternalCustomerGeneralInfo extends Component {
	constructor(props) {
		super(props);
		this.state = {error: {}, filteredTaxOffices: [], taxOffices: []};
		this.validateField = this.validateField.bind(this);
		this.validateClass = this.validateClass.bind(this);
		this.validateMessage = this.validateMessage.bind(this);
		this.validateComponent = this.validateComponent.bind(this);
		this.onBlurVknTckn = this.onBlurVknTckn.bind(this);
		this.onCityChange = this.onCityChange.bind(this);
		this.onChangeVknTckn = this.onChangeVknTckn.bind(this);
		this.onChangeVknTcknSelect = this.onChangeVknTcknSelect.bind(this);
	}

	componentDidMount() {
		let self = this;
		let city = self.props.externalCustomer.city;
		let params = {
			url: `/externalCustomer/getCodes`,
			method: 'post'
		};
		request(params)
			.then(response => {
				let taxOffices = response.data.taxOffices;
				let filteredTaxOffices = taxOffices.filter(to => to.city === city);
				self.setState({city, filteredTaxOffices, taxOffices});
			})
			.catch(function (error) {
				showAxiosError(error);
				self.setState({city});
			});
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		let externalCustomer = this.props.externalCustomer
		if (this.props.changeExternalCustomer !== undefined && this.props.changeExternalCustomer === true){
			let city = {value: externalCustomer.city, label: externalCustomer.city}
			let taxOffice = externalCustomer.taxOffice.replace("MÜD.", "MÜDÜRLÜĞÜ");
			this.onCityChange(city)
			this.props.onChangeExternalCustomer({target: {value: taxOffice, name: "taxOffice"}})
		}
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength;
		let result = validateField(rule, boundary, e.target.value);
		let error = this.state.error;
		error = Object.assign(error, {[id]: result});
		this.setState({error});
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	validateComponent() {
		let result = validateComponent(this);
		this.setState({
			error: result.error
		});
		return result
	}

	onBlurVknTckn(e) {
		let error = deepCopyObject(this.state.error);
		this.validateField(e);
		if (!!this.props.externalCustomer.vknTckn && (this.props.externalCustomerMainType === ExternalCustomerMainType.Normal)) {
			this.checkIfVknExists(this.props.externalCustomer.vknTckn);
		}
		if (e.target.value.length === 10) {
			if (error.tGivenName) {
				delete error.tGivenName;
				this.setState({error})
			}
			if (error.tFamilyName) {
				delete error.tFamilyName;
				this.setState({error})
			}
		}
		if (e.target.value.length === 11) {
			if (error.tFormattedName) {
				delete error.tFormattedName;
				this.setState({error})
			}
		}
	}
	
	onChangeVknTckn(e){
		e.target.value = e.target.value.replace(/\s/g, '');
		this.props.onChangeExternalCustomer(e);
	}

	onChangeVknTcknSelect(e){
		let e_ = {target:{name:"vknTckn",value:e.value}};
		this.props.onChangeExternalCustomer(e_);
	}

	checkIfVknExists(value) {
		let self = this;
		const data = value;
		let params = {
			url: `/externalCustomer/findByVknTckn`,
			data: data,
			method: 'post'
		};
		request(params).then(function (response) {
			if ((response.data && !self.props.externalCustomer.recordId) ||
				(response.data && self.props.externalCustomer.recordId && self.props.externalCustomer.recordId !== response.data.recordId)) {
				let tVknTckn = {
					valid: false,
					message: "Bu Vkn/Tckn'li Müşteri Zaten Mevcut"
				};
				let error = deepCopyObject(self.state.error);
				error.tVknTckn = tVknTckn;
				self.setState({
					error
				});
				Alert.error('Bu Vkn/Tckn\'li Müşteri Zaten Mevcut', {
					html: true,
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				})
			}
		})
			.catch(function (error) {
				showAxiosError(error);
			});
	}

	onCityChange(e) {
		let taxOffices = this.state.taxOffices;
		let filteredTaxOffices = [];
		let city = null;
		if(e){
			filteredTaxOffices = taxOffices.filter(to => to.city === e.value);
			city=e.value;
		}else{
			filteredTaxOffices=[];
			city=null;
		}
		this.setState({city, filteredTaxOffices});
		this.props.onChangeExternalCustomer({target: {name: "city", value: city}});
	}

	render() {

		let customerTypes = [
			{label: 'Satıcı', value: '1'},
			{label: 'Alıcı', value: '2'},
			{label: 'Her İkisi', value: '3'}
		];

		let mixedCustomerVknTckn =[
			{label: '55555555555 (Şahıs)', value:'55555555555'},
			{label: '5555555555 (Şirket)', value:'5555555555'}
		];

		return (
			<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 row">
				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>VKN/TCKN *</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							{(this.props.externalCustomerMainType !== ExternalCustomerMainType.DespatchMixed) ?
									<div className={"form-group" + this.validateClass('tVknTckn')}>
										<input className="form-control"
											   maxLength="11"
											   type="text"
											   name="vknTckn"
											   id="tVknTckn"
											   data-vlength="10,11"
											   data-vdata="identifier"
											   onBlur={(e) => this.onBlurVknTckn(e)}
											   ref="tVknTckn"
											   value={this.props.externalCustomer.vknTckn}
											   onChange={(e) => this.onChangeVknTckn(e)}/>
										{this.validateMessage('tVknTckn') !== "" &&
										<UncontrolledTooltip placement="right" target="tVknTckn"
															 delay={0}>
											{this.validateMessage("tVknTckn")}
										</UncontrolledTooltip>}

									</div>
									:
									<div className={"form-group" + this.validateClass('tVknTckn')}>
										<Select className="select-control"
												name="vknTckn"
												id="tVknTckn"
												value={this.props.externalCustomer.vknTckn ? this.props.externalCustomer.vknTckn  : "5555555555"}
												clearable={false}
												placeholder="Seçiniz..."
												onChange={(e) => this.onChangeVknTcknSelect(e)}
												ref="tVknTckn"
												options={mixedCustomerVknTckn}/>
										{this.validateMessage('tVknTckn') !== "" &&
										<UncontrolledTooltip placement="right" target="tVknTckn" delay={0}>
											{this.validateMessage("tVknTckn")}
										</UncontrolledTooltip>}
									</div>
							}
					</div>
				</div>

				{(this.props.externalCustomer.vknTckn === null || this.props.externalCustomer.vknTckn.length !== 11) &&
				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Unvan *</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass('tFormattedName')}>
								<input className="form-control"
									   type="text"
									   name="formattedName"
									   id="tFormattedName"
									   data-vlength="2,350"
									   onBlur={this.validateField}
									   ref="tFormattedName"
									   value={this.props.externalCustomer.formattedName}
									   onChange={(e) => this.props.onChangeExternalCustomer(e)}/>
								{this.validateMessage('tFormattedName') !== "" &&
								<UncontrolledTooltip placement="right" target="tFormattedName"
													 delay={0}>
									{this.validateMessage("tFormattedName")}
								</UncontrolledTooltip>}
							</div>
					</div>
				</div>
				}

				{this.props.externalCustomer.vknTckn !== null && this.props.externalCustomer.vknTckn.length === 11 &&
				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Unvan</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<input className="form-control"
								   type="text"
								   name="formattedName"
								   id="tFormattedName"
								   data-vlength="0,350"
								   onBlur={this.validateField}
								   ref="tFormattedName"
								   value={this.props.externalCustomer.formattedName}
								   onChange={(e) => this.props.onChangeExternalCustomer(e)}/>
						{this.validateMessage('tFormattedName') !== "" &&
							<UncontrolledTooltip placement="right" target="tFormattedName"
												 delay={0}>
								{this.validateMessage("tFormattedName")}
							</UncontrolledTooltip>}
					</div>
				</div>
				}

				{this.props.externalCustomer.vknTckn !== null && this.props.externalCustomer.vknTckn.length === 11 &&
				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Adı *</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass('tGivenName')}>
								<input className="form-control"
									   type="text"
									   name="givenName"
									   id="tGivenName"
									   data-vlength="1,45"
									   onBlur={this.validateField}
									   ref="tGivenName"
									   value={this.props.externalCustomer.givenName}
									   onChange={(e) => this.props.onChangeExternalCustomer(e)}/>
								{this.validateMessage('tGivenName') !== "" &&
								<UncontrolledTooltip placement="right" target="tGivenName"
													 delay={0}>
									{this.validateMessage("tGivenName")}
								</UncontrolledTooltip>}
							</div>
					</div>
				</div>
				}

				{(this.props.externalCustomer.vknTckn === null || this.props.externalCustomer.vknTckn.length !== 11) &&
				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Adı</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className="form-group">
								<input className="form-control"
									   type="text"
									   name="givenName"
									   id="tGivenName"
									   data-vlength="0,45"
									   onBlur={this.validateField}
									   ref="tGivenName"
									   value={this.props.externalCustomer.givenName || ''}
									   onChange={(e) => this.props.onChangeExternalCustomer(e)}/>
							</div>
					</div>
				</div>
				}

				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Orta Adı </label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className="form-group">
								<input className="form-control"
									   type="text"
									   id = "tMiddleName"
									   name="middleName"
									   data-vlength="0,45"
									   onBlur={this.validateField}
									   ref = "tMiddleName"
									   value={this.props.externalCustomer.middleName || ''}
									   onChange={(e) => this.props.onChangeExternalCustomer(e)}/>
							</div>
					</div>
				</div>

				{this.props.externalCustomer.vknTckn !== null && this.props.externalCustomer.vknTckn.length === 11 &&
				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Soyadı *</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass('tFamilyName')}>
								<input className="form-control"
									   type="text"
									   name="familyName"
									   id="tFamilyName"
									   data-vlength="1,45"
									   onBlur={this.validateField}
									   ref="tFamilyName"
									   value={this.props.externalCustomer.familyName || ''}
									   onChange={(e) => this.props.onChangeExternalCustomer(e)}/>
								{this.validateMessage('tFamilyName') !== "" &&
								<UncontrolledTooltip placement="right" target="tFamilyName"
													 delay={0}>
									{this.validateMessage("tFamilyName")}
								</UncontrolledTooltip>}
							</div>
					</div>

					{/*<div className={"col-sm-8 form-group" + this.validateClass('tFamilyName')} style={{maxWidth: "none"}}>*/}
					{/*<input className="form-control"*/}
					{/*type="text"*/}
					{/*name="familyName"*/}
					{/*id="tFamilyName"*/}
					{/*data-vlength="1,45"*/}
					{/*onBlur={this.validateField}*/}
					{/*ref="tFamilyName"*/}
					{/*value={this.props.externalCustomer.familyName}*/}
					{/*onChange={(e) => this.props.onChangeExternalCustomer(e)}/>*/}
					{/*{this.validateMessage('tFamilyName') !== "" &&*/}
					{/*<UncontrolledTooltip placement="right" target="tFamilyName"*/}
					{/*delay={0}>*/}
					{/*{this.validateMessage("tFamilyName")}*/}
					{/*</UncontrolledTooltip>}*/}
					{/*</div>*/}

				</div>
				}

				{(this.props.externalCustomer.vknTckn === null || this.props.externalCustomer.vknTckn.length !== 11) &&
				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Soyadı</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className="form-group">
								<input className="form-control"
									   type="text"
									   name="familyName"
									   id="tFamilyName"
									   data-vlength="0,45"
									   onBlur={this.validateField}
									   ref="tFamilyName"
									   value={this.props.externalCustomer.familyName}
									   onChange={(e) => this.props.onChangeExternalCustomer(e)}/>
							</div>
					</div>
				</div>
				}

                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Tic. Odası </label>
                    </div>
                    <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className="form-group">
								<input className="form-control"
									   type="text"
									   name="commerceChamber"
									   value={this.props.externalCustomer.commerceChamber}
									   onChange={(e) => this.props.onChangeExternalCustomer(e)}/>
							</div>
                    </div>
                </div>

                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Vergi D. Şehir</label>
                    </div>
                    <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className="form-group">
								<Select
										clearable={true}
										className="select-control"
										name="city"
										value={this.state.city}
										placeholder="Seçiniz..."
										onChange={(e) => this.onCityChange(e)}
										options={this.props.cities.map(city => ({
											value: city.cityName,
											label: city.cityName
										}))}
								/>
							</div>
                    </div>
                </div>

                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Vergi D.</label>
                    </div>
                    <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className={"form-group" + this.validateClass('tTaxOffice')}>
								<Select
										clearable={true}
										className="select-control"
										name="taxOffice"
										id="tTaxOffice"
										onBlur={() => this.validateField({
											target: {
												id: "tTaxOffice",
												dataset: {'vlength': (this.props.requiredTaxOffice ? "1,255" :"0,255")}
											}
										})}
										inputProps={{'vlength':(this.props.requiredTaxOffice ? "1,255" :"0,255")}}
										ref="tTaxOffice"
										value={this.props.externalCustomer.taxOffice}
										placeholder="Seçiniz..."
										onChange={(e) => this.props.onChangeExternalCustomer({target: {value: (e ? e.value:null), name: "taxOffice"}})}
										options={this.state.filteredTaxOffices.map(to => ({
											value: to.vdName,
											label: to.vdName
										}))}
								/>
								{this.validateMessage('tTaxOffice') !== "" &&
								<UncontrolledTooltip placement="right" target="tTaxOffice" delay={0}>
									{this.validateMessage("tTaxOffice")}
								</UncontrolledTooltip>}
							</div>
                    </div>
                </div>

				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Mersis No </label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className="form-group">
								<input className="form-control"
									   maxLength="16"
									   type="text"
									   name="mersisNumber"
									   value={this.props.externalCustomer.mersisNumber}
									   onChange={(e) => this.props.onChangeExternalCustomer(e)}/>
							</div>
					</div>
				</div>

				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Tic.Sic. No </label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className="form-group">
								<input className="form-control"
									   type="text"
									   name="tradeRegistrationNumber"
									   value={this.props.externalCustomer.tradeRegistrationNumber}
									   onChange={(e) => this.props.onChangeExternalCustomer(e)}/>
							</div>
					</div>
				</div>

				{this.props.size === 12 &&
				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Müşteri Tipi </label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className="form-group">
								<Select
										clearable={false}
										className="select-control"
										value={this.props.customerType}
										placeholder="Seçiniz..."
										onChange={(e) => this.props.onChangeType(e)}
										options={customerTypes.map(ct => ({
											value: ct.value,
											label: ct.label
										}))}
								/>
							</div>
					</div>
				</div>}

				{this.props.size === 12 &&
				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							<label>Başlangıç Bakiyesi</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className="form-group">
								<NumberFormat className="form-control"
											  allowNegative={false}
											  isNumericString={true}
											  decimalScale={2}
											  displayType="input"
											  value={this.props.externalCustomer.initialBalance}
											  onValueChange={(e) => this.props.onChangeRiskLimitOrBalance({
												  value: e.value,
												  name: "initialBalance"
											  })}/>
							</div>
					</div>
				</div>}

				{this.props.size === 12 &&
				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row">
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
							{/*<label className="col-form-label">Müşteri Risk Limiti</label>*/}
							<label>Müşteri Risk Limiti</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<div className="form-group">
								<NumberFormat className="form-control"
											  allowNegative={false}
											  isNumericString={true}
											  decimalScale={2}
											  displayType="input"
											  value={this.props.externalCustomer.customerRiskLimit}
											  onValueChange={(e) => this.props.onChangeRiskLimitOrBalance({
												  value: e.value,
												  name: "customerRiskLimit"
											  })}/>
							</div>
					</div>
				</div>}
			</div>
		)
	}
}

export default ExternalCustomerGeneralInfo;